import ProjectSession from "../../../../../core/model2/project/project-session"
import MoveManager from "../../../../../core/gd/manager/move-manager"
import {EVENT_BUS_MENU_RERENDER} from "../../const"

// const debug = "menu_reorderProjects"
const debug = false

export default function menu_reorderProjects(sortedMapID: string, parentProjectId: ID, data: {
    originalOrderedProjects : ProjectSession[],
    reorderedProjects       : ProjectSession[],
    projectMoved            : ProjectSession,
}) {
    const parentProject = gd.session.projects.get(parentProjectId)

    debug && console.log(debug, 'process', parentProject, data.projectMoved.sortPosition, data.projectMoved.id)

    // check project access if parent is found or company access if no parent found
    const hasFullAccess = parentProject ? parentProject.acl.hasFullAccess : gd.ac.check.company.isManager()

    // sortedMap outranks sortPosition (menu_sortProjects), so it is only a fallback for users who cannot
    // save sortPosition - kept for anyone who can, it would freeze this list against later server changes
    if (hasFullAccess) {
        delete gd.user.menu.projectsAll.sortedMap[sortedMapID]
    } else {
        gd.user.menu.projectsAll.sortedMap[sortedMapID] = _.map(data.reorderedProjects, (project: ProjectSession) => project.id)
    }
    gd.user.menu.save()

    // "Reset manual sorting" availability depends on sortedMap, so refresh the menu popover options right after a drag
    gd.bus.triggerEvent(EVENT_BUS_MENU_RERENDER)

    if (data.projectMoved && hasFullAccess) {

        // since the number of projects has not changed, the sort positions should remain at the same indexes in the array
        // so we can set the sort positions for the new reordered projects according to their index in the array.
        // Sorted, since a stale sortedMap may have rendered the original list out of sortPosition order
        const originalOrderedProjectsSortPositions = _.sortBy(_.map(data.originalOrderedProjects, (project: ProjectSession) => project.sortPosition))

        _.map(data.reorderedProjects, (project: ProjectSession, key: number) => {
            debug && console.log(debug, 'process map', project.sortPosition, originalOrderedProjectsSortPositions[key], project.id)
            project.sortPosition = originalOrderedProjectsSortPositions[key]
        })

        debug && console.log(debug, 'process MoveManager', data.projectMoved.sortPosition, data.projectMoved.id)

        MoveManager.setProjectSortPosition(data.projectMoved.id, data.projectMoved.sortPosition)
    }
}